module.exports = __webpack_public_path__ + "img/gc_country_flag_ve.076c1794.svg";